import { render, staticRenderFns } from "./ArticleItemDetail.vue?vue&type=template&id=32579690&scoped=true&"
import script from "./ArticleItemDetail.vue?vue&type=script&lang=js&"
export * from "./ArticleItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArticleItemDetail.vue?vue&type=style&index=0&id=32579690&scoped=true&lang=css&"
import style1 from "./ArticleItemDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32579690",
  null
  
)

export default component.exports